import React from "react";
import Link from "../atoms/Link";
import Label from "../atoms/Label";
import Image from "../atoms/Image";

export default ({ image, tag, title, desc, link, translations }) =>
    <Link className="o-special-event u-object-fit u-object-fit--3-2" link={ link } translations={ translations }>
        { tag &&
        <div className="o-special-event__tag">
            <Label text={ tag }/>
        </div>
        }
        <Image className="o-special-event__image u-object-fit__media" image={ image }/>
        <div className="o-special-event__content">
            { title && <p className="o-special-event__title">{ title }</p> }
            { desc && <p className="o-special-event__desc">{ desc }</p> }
        </div>
    </Link>;
